'use client';

import type { RetentionItem } from '@/data/types';

interface RetentionViewProps {
  retentionData: readonly RetentionItem[];
  onSelectMember: (id: string) => void;
  onShowToast: (message: string) => void;
}

export default function RetentionView({
  retentionData,
  onSelectMember,
  onShowToast,
}: RetentionViewProps) {
  return (
    <div className="dashboard-view active">
      <h2 className="dash-heading">Retention Intelligence</h2>
      <p className="dash-subtext">
        Members sorted by who needs care first. Churn signals, renewal windows,
        and the narrative context behind the numbers.
      </p>
      <div className="retention-list">
        {retentionData.map((r, i) => (
          <div
            key={i}
            className="retention-card"
            onClick={() => onSelectMember(r.id)}
          >
            <div className={`retention-risk-indicator ${r.riskLevel}`}>
              {r.riskScore}
            </div>
            <div className="retention-info">
              <div className="retention-name">{r.name}</div>
              <div className="retention-context">{r.context}</div>
              <div className="retention-signals">
                {r.signals.map((s, j) => (
                  <span key={j} className={`retention-signal ${s.type}`}>
                    {s.text}
                  </span>
                ))}
              </div>
            </div>
            <div className="retention-action-col">
              <div className="retention-renewal">{r.renewal}</div>
              <button
                className="opp-btn primary"
                onClick={(e) => {
                  e.stopPropagation();
                  onShowToast(`Check-in drafted for ${r.name}`);
                }}
              >
                Draft Check-in
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
